/*
  Local currency conversion for product pages based on a static EUR->local exchange table.
  - Detect current active currency via Shopify/Currency cookie/DOM hints
  - Parse the displayed price (sale preferred) and convert from EUR to target currency
  - Re-render price text using Intl.NumberFormat with correct local currency symbol
  - Observe DOM changes so variant price updates get converted automatically

  NOTE:
  - Rates below are examples; please adjust to your business policy.
  - This affects only UI display; Shopify checkout/charges still use store/market currency.
*/
(function(){
  // Deprecated: use server-provided data attributes on .price for conversion config
  const EXCHANGE_TABLE = {};

  const LOCALE_CURRENCY_MAP = {
    'zh': 'CNY', 'zh-cn': 'CNY',
    'ro': 'RON',
    'cs': 'CZK',
    'pl': 'PLN',
    'hu': 'HUF',
    'sv': 'SEK',
    'da': 'DKK',
    'nb': 'NOK', 'no': 'NOK',
    'bg': 'BGN'
  };

  function detectLocaleFromPath(){
    try {
      const path = window.location && window.location.pathname ? window.location.pathname : '';
      const m = path.match(/^\/(?:([a-z]{2}|[a-z]{2}-[A-Za-z]{2}))(?:\/|$)/);
      if (m && m[1]) return m[1];
      return document.documentElement.lang || '';
    } catch(_) {
      return document.documentElement.lang || '';
    }
  }

  function localeToCurrency(locale){
    const key = String(locale || '').trim().toLowerCase();
    const cur = LOCALE_CURRENCY_MAP[key] || '';
    return (cur && EXCHANGE_TABLE[cur]) ? cur : '';
  }

  function detectActiveCurrency(fallback){
    try {
      const fromShopify = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : '';
      const fromCurrencyJS = (window.Currency && (window.Currency.currentCurrency || (window.Currency.cookie && window.Currency.cookie.read && window.Currency.cookie.read()))) || '';
      const fromLS = (typeof window.localStorage !== 'undefined') ? (
        localStorage.getItem('currency') ||
        localStorage.getItem('activeCurrency') ||
        ''
      ) : '';
      const fromCookieMatch = (document.cookie || '').match(/(?:^|; )(?:currency|activeCurrency)=([^;]+)/);
      const fromCookie = fromCookieMatch ? decodeURIComponent(fromCookieMatch[1]) : '';
      const fromDom = (document.body && document.body.dataset && document.body.dataset.activeCurrency) ? document.body.dataset.activeCurrency : '';
      const fromLocale = localeToCurrency(detectLocaleFromPath()) || '';
      // 优先使用路径语言前缀映射到的当地币种，其次再考虑 Shopify/cookie 等来源
      const cur = (fromLocale || fromShopify || fromCurrencyJS || fromLS || fromCookie || fromDom || fallback || '').toString().trim();
      return cur ? cur.toUpperCase() : (fallback || '').toUpperCase();
    } catch(_) {
      return (fallback || '').toUpperCase();
    }
  }

  function getDisplayedPriceText(){
    try {
      const saleEl = document.querySelector('.price .price-item--sale.price-item--last');
      const regEl = document.querySelector('.price .price-item.price-item--regular');
      const text = (saleEl || regEl)?.textContent || '';
      return String(text || '').trim();
    } catch (_) {
      return '';
    }
  }

  function parseCurrencyFromPriceText(text){
    try {
      const s = String(text || '').trim();
      if (!s) return '';
      const codeMatch = s.match(/\b([A-Z]{3})\b/);
      if (codeMatch && codeMatch[1]) return codeMatch[1].toUpperCase();
      const symbolMap = { '€': 'EUR', '$': 'USD', '£': 'GBP', '¥': 'CNY', '￥': 'CNY', '元': 'CNY', 'lei': 'RON', 'RON': 'RON', 'Kč': 'CZK' };
      for (const [sym, code] of Object.entries(symbolMap)) {
        if (s.includes(sym)) return code;
      }
      return '';
    } catch (_) {
      return '';
    }
  }

  function parsePriceNumber(text){
    try {
      const raw = String(text || '').trim();
      if (!raw) return NaN;
      const cleaned = raw.replace(/[^0-9.,-]/g, '');
      if (cleaned.includes(',') && cleaned.includes('.')) {
        const normalized = cleaned.replace(/\./g, '').replace(/,/g, '.');
        return parseFloat(normalized);
      }
      if (cleaned.includes(',')) {
        const normalized = cleaned.replace(/,/g, '.');
        return parseFloat(normalized);
      }
      return parseFloat(cleaned);
    } catch (_) {
      return NaN;
    }
  }

  function formatCurrency(amount, currencyCode, locale){
    try {
      const v = typeof amount === 'number' ? amount : parseFloat(amount || '0');
      const lang = locale || (document.documentElement.lang || 'en');
      const cur = (currencyCode || 'EUR').toUpperCase();
      const fmt = new Intl.NumberFormat(lang, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' });
      return fmt.format(isNaN(v) ? 0 : v);
    } catch(_) {
      const v = typeof amount === 'number' ? amount : parseFloat(amount || '0');
      return `${currencyCode || ''} ${isNaN(v) ? '0.00' : v.toFixed(2)}`;
    }
  }

  function convertFromEUR(valueEUR, targetCode){
    const t = EXCHANGE_TABLE[(targetCode || '').toUpperCase()];
    if (!t) return null;
    return { amount: (valueEUR || 0) * t.rate, currency: t.currency, locale: t.locale };
  }

  function applyConversion(priceWrap) {
    if (!priceWrap) priceWrap = document.querySelector('.price');
    if (!priceWrap) return;
  
    const ds = priceWrap.dataset || {};
    const regularEl = priceWrap.querySelector('.price-item--regular');
    const saleEl = priceWrap.querySelector('.price-item--sale');
    const compareEl = priceWrap.querySelector('.price-item--regular s, s.price-item--regular, .variant-item__old-price');
    const perItemEls = priceWrap.querySelectorAll('.price-per-item--current');
  
    // If server provided conversion config via data attributes, prefer that over static tables
    if (ds.convert === 'true') {
      const rate = parseFloat(ds.rate);
      const targetCurrencyCode = ds.currencyCode || '';
      const targetSymbol = ds.currencySymbol || '';
      const decimals = ds.decimals ? parseInt(ds.decimals, 10) : 2;
      const floorAfter = (ds.floor === 'true') || (ds.floorAfterConversion === 'true') || (targetCurrencyCode && targetCurrencyCode.toUpperCase() !== 'EUR');

      // Avoid double conversion: if text already shows target symbol/code, skip conversion
      const displayedText = (saleEl || regularEl)?.textContent || '';
      const parsedCode = parseCurrencyFromPriceText(displayedText);
      const alreadyHasSymbol = targetSymbol && displayedText.includes(targetSymbol);
      const alreadyHasCode = targetCurrencyCode && (parsedCode === targetCurrencyCode);
      if (alreadyHasSymbol || alreadyHasCode) {
        // 即使已是目标币种，也需要在 floorAfter=true 时进行“仅取整”的格式化
        if (floorAfter) {
          const lang = (document.documentElement && document.documentElement.lang) ? document.documentElement.lang : undefined;
          const fmtCode = parsedCode || targetCurrencyCode || detectActiveCurrency('RON');
          const formatFloor = (node) => {
            if (!node) return;
            const num = parsePriceNumber(node.textContent);
            if (isNaN(num)) return;
            const val = Math.floor(num);
            try {
              node.textContent = new Intl.NumberFormat(lang, {
                style: 'currency',
                currency: fmtCode,
                currencyDisplay: 'narrowSymbol',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(val);
            } catch (_) {
              const symbol = targetSymbol || (fmtCode === 'RON' ? 'lei' : '');
              node.textContent = `${symbol}${val}`.trim();
            }
          };
          formatFloor(regularEl);
          formatFloor(saleEl);
          formatFloor(compareEl);
          perItemEls.forEach(formatFloor);
        }
        priceWrap.dataset.convertedCurrency = targetCurrencyCode || targetSymbol || 'converted';
        return;
      }

      const formatAmount = (num) => {
        const lang = (document.documentElement && document.documentElement.lang) ? document.documentElement.lang : undefined;
        const decimalsFinal = floorAfter ? 0 : decimals;
        const numToFormat = floorAfter ? Math.floor(Number(num || 0)) : Number(num || 0);
        if (targetCurrencyCode) {
          try {
            return new Intl.NumberFormat(lang, {
              style: 'currency',
              currency: targetCurrencyCode,
              currencyDisplay: 'narrowSymbol',
              minimumFractionDigits: decimalsFinal,
              maximumFractionDigits: decimalsFinal,
            }).format(numToFormat);
          } catch (_) {
            // Fallback to symbol + fixed
            return `${targetSymbol}${numToFormat.toFixed(decimalsFinal)}`;
          }
        }
        return `${targetSymbol}${numToFormat.toFixed(decimalsFinal)}`;
      };

      const parseBaseEUR = (text) => {
        // Try to extract numeric value regardless of symbol; we assume base was EUR on server
        const num = parseFloat(String(text).replace(/[^0-9.,-]/g, '').replace(',', '.'));
        return isNaN(num) ? null : num;
      };

      const convertNode = (node) => {
        if (!node) return;
        const baseVal = parseBaseEUR(node.textContent);
        if (baseVal == null || isNaN(rate)) return;
        let converted = baseVal * rate;
        if (floorAfter) converted = Math.floor(converted);
        node.textContent = formatAmount(converted);
      };

      // Only convert when server output is still base money (e.g., when variant switches client-side)
      // If server already rendered converted values, we simply leave as-is.
      // Here we re-apply based on numeric extraction and provided rate.
      convertNode(regularEl);
      convertNode(saleEl);
      convertNode(compareEl);
      perItemEls.forEach(convertNode);

      priceWrap.dataset.convertedCurrency = targetCurrencyCode || targetSymbol || 'converted';
      return; // Skip legacy table-based conversion
    }

    // No server-provided conversion config; apply fallback flooring for RON/ro pages
    {
      const regularEl = priceWrap.querySelector('.price-item--regular');
      const saleEl = priceWrap.querySelector('.price-item--sale');
      const compareEl = priceWrap.querySelector('.price-item--regular s, s.price-item--regular, .variant-item__old-price');
      const displayedText = (saleEl || regularEl)?.textContent || '';
      const codeFromText = parseCurrencyFromPriceText(displayedText);
      const activeCode = detectActiveCurrency('RON');
      const lang = (document.documentElement && document.documentElement.lang) ? document.documentElement.lang : 'ro';
      const shouldFloor = (codeFromText === 'RON') || (activeCode === 'RON') || /^ro/i.test(lang || '');

      const floorNode = (node) => {
        if (!node || !shouldFloor) return;
        const num = parsePriceNumber(node.textContent);
        if (isNaN(num)) return;
        const currencyCode = (codeFromText || activeCode || 'RON');
        try {
          const fmt = new Intl.NumberFormat(lang, {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
          node.textContent = fmt.format(Math.floor(num));
        } catch (_) {
          const symbol = currencyCode === 'RON' ? 'lei' : '';
          node.textContent = `${symbol}${Math.floor(num)}`.trim();
        }
      };

      floorNode(regularEl);
      floorNode(saleEl);
      floorNode(compareEl);
      perItemEls.forEach(floorNode);
    }

    // No server-provided conversion config; skip legacy conversion to avoid duplicate maintenance.
    return;
  }


  function initObserver(){
    try {
      let root = document.querySelector('.price');
      if (root) {
        const mo = new MutationObserver(() => applyConversion());
        mo.observe(root, { childList: true, subtree: true, characterData: true });
        return;
      }
      const bootMo = new MutationObserver(() => {
        root = document.querySelector('.price');
        const hasText = !!getDisplayedPriceText();
        if (root && hasText) {
          try { applyConversion(); } catch(_){}
          const mo = new MutationObserver(() => applyConversion());
          mo.observe(root, { childList: true, subtree: true, characterData: true });
          bootMo.disconnect();
        }
      });
      const target = document.body || document.documentElement;
      if (target) {
        bootMo.observe(target, { childList: true, subtree: true });
      }
    } catch(_){}
  }

  document.addEventListener('DOMContentLoaded', function(){
    applyConversion();
    initObserver();
  });
  document.addEventListener('price-refresh', function(){ try{ applyConversion(); }catch(e){} });
  try { window.__applyCurrencyConversion = applyConversion; } catch(_){}
})();